import { lazyTranslateItem } from 'owa-mail-inline-translation';
import ItemViewState from 'owa-mail-reading-pane-store/lib/store/schema/ItemViewState';
import getConversationSubject from 'owa-mail-reading-pane-store/lib/utils/getConversationSubject';
import { ClientItem } from 'owa-mail-store';
import * as React from 'react';

export default function onTranslate(item: ClientItem, viewState: ItemViewState) {
    return (event: React.KeyboardEvent<HTMLElement> | React.MouseEvent<HTMLElement>) => {
        event.stopPropagation();

        lazyTranslateItem.importAndExecute(
            item.ItemId.Id,
            getConversationSubject(item.ConversationId?.Id),
            viewState.isConversationItemPart,
            true /* manualTranslation */
        );
    };
}
